import { z } from "zod";

export const UserHubspotTokenSchema = z.object({
  token: z.string(),
});

export type UserHubspotTokenType = z.infer<typeof UserHubspotTokenSchema>;
